module.exports = __webpack_public_path__ + "media/images/sp/static/icon-best-605c274360e6ceef2ef6b5dc035350ba.png";